import React, {Component} from 'react';

/** Read-only nodes table (editing is graph-view-only). */
class NodesTable extends Component {
  render() {
    const {rows, characteristicIndex, groupIndex} = this.props;

    return (
      <div className="lt-section">
        <div className="lt-section-header">
          <span className="lt-section-title">Nodes</span>
        </div>
        <table className="data-table lt-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Role</th>
              <th>Ext</th>
              <th>Characteristic</th>
              <th>Environment</th>
              <th>Group</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={7} className="lt-empty-row">No nodes.</td></tr>
            )}
            {rows.map((n) => {
              const data = n.data || {};
              const details = data.details || {};
              const role = data.isSource ? 'Source' : (data.isDestination ? 'Destination' : '—');
              const charName = characteristicIndex[data.characteristicId] || '—';
              const groupName = groupIndex[n.parentId] || '—';
              return (
                <tr key={n.id} data-testid={`lt-node-row-${n.id}`}>
                  <td>{data.label || <em>Untitled</em>}</td>
                  <td>{data.appType || 'application'}</td>
                  <td>{role}</td>
                  <td>{details.isExternal ? '🌐' : ''}</td>
                  <td>{charName}</td>
                  <td>{details.environment || '—'}</td>
                  <td>{groupName}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default NodesTable;
